import { useSelector, useDispatch } from 'react-redux';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
// @mui material components
import Link from "@mui/material/Link";
import IconButton from "@mui/material/IconButton";
import LogoutIcon from '@mui/icons-material/Logout';
import Tooltip from '@mui/material/Tooltip';
import EditIcon from '@mui/icons-material/Edit';
// Argon Dashboard 2 MUI components
import ArgonButton from "../ArgonButton";
import ArgonBox from "../ArgonBox";
import ArgonTypography from "../ArgonTypography";
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import PasswordIcon from '@mui/icons-material/Password';

// Argon Dashboard 2 MUI context

// Images
import icon from "../../../assets/images/illustrations/icon-documentation.svg";
import sidenavLogoLabel from './styles/sidenav';
import { authActions } from '../../../helpers/store';
import { clearInvoices } from '../../../slices/invoices.slice';
import { clearStatistics } from '../../../slices/statistics.slice';
import { addComma } from '../../../helpers/mmg';
import { useNavigate } from 'react-router-dom';

const bull = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}
  >
    •
  </Box>
);


function SidenavFooter() {
  //const [controller] = useArgonController();
  //const { miniSidenav, darkSidenav } = controller;
  const page = useSelector(x => x.page);
  const dispatch = useDispatch();
  let navigate = useNavigate();

  const darkMode = page.darkMode;
  const miniSidenav = page.miniSidenav;
  const transparentNavbar = page.transparentNavbar;
  const fixedNavbar = page.fixedNavbar;
  const openConfigurator = page.openConfigurator;
  const darkSidenav = page.darkSidenav;
  const { user: authUser } = useSelector(x => x.auth);
  const defaultValues = JSON.parse(localStorage.getItem('defaultValue'));
  const mainDefaultValues = useSelector(x => x.defaultValue);


  const logout = () => {

    dispatch(clearInvoices());
    dispatch(clearStatistics());
    dispatch(authActions.logout());

  }

  const changePass = () => {

    navigate('/ChangePass');

  }

  return mainDefaultValues.Loading ? 
  <span><Backdrop 
  sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
  open={true}
>
  <CircularProgress color="inherit" />
</Backdrop></span> : 

        (miniSidenav ? <Tooltip title="خروج"><IconButton onClick={logout} color="dark"><LogoutIcon /></IconButton></Tooltip>
            //color={!darkMode && transparentNavbar ? "white" : "dark"}
          :  
        (authUser.role !== "CustomerPortal" &&  authUser.role !== "FinancialPersonnel"?
      <CardActions>
          <table width='100%'>
             <tr>
             <td colSpan={2}>
             <Typography className='sideNavFooter1' gutterBottom >
                کاربر: {authUser?.username}
              </Typography>
                  </td>
             </tr>
              <tr>
                <td>
                <Tooltip title="تغییر رمز">
                  <IconButton onClick={changePass}
                  color="dark"
                  //color={!darkMode && transparentNavbar ? "white" : "dark"}
                   >
                    <PasswordIcon />
                  </IconButton>
                 </Tooltip>
                  </td>
                <td>
                  <Tooltip title="خروج">
                  <IconButton onClick={logout}
                    color="dark"
                    //color={!darkMode && transparentNavbar ? "white" : "dark"}
                    >
                    <LogoutIcon />
                  </IconButton></Tooltip>
                  </td>
              </tr>
            </table> 
      </CardActions> : 
        
      <ArgonBox opacity={miniSidenav ? 0 : 1} sx={{ transition: "opacity 200ms linear" }} className='sideNavFooter4'>
        <ArgonBox position="relative" textAlign="center" className='sideNavFooter5' >
          <Typography className='sideNavFooter3' gutterBottom >
            {authUser?.dlTitle}
          </Typography>
          <hr/>
          <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
              تراز مالی
          </Typography>
            <Card>
            <CardContent className='sideNavFooter2'>
            <Typography className='sideNavFooter1' gutterBottom >
                کد مشتری : {authUser?.dlCode}
              </Typography>
              <table width='100%'>
                <tr >
                  <td style={{textAlign : 'right'}}><h6>کیف پول</h6></td>
                  <td style={{textAlign : 'left'}}><h6 style={{textAlign : 'left'}}>{defaultValues != null && defaultValues.CustomerSaleAndFinancialDataModel !== null ? (defaultValues.CustomerSaleAndFinancialDataModel.a8 !== null ? (defaultValues.CustomerSaleAndFinancialDataModel.a8.includes("-") ? defaultValues.CustomerSaleAndFinancialDataModel.a8.replaceAll("-","") : "0" ) : "0") +  " ریال" : ""}</h6></td>
                </tr>
                <tr>
                  <td style={{textAlign : 'right'}}><h6>مانده</h6></td>
                  <td style={{textAlign : 'left'}}><h6 style={{textAlign : 'left'}}>{defaultValues != null && defaultValues.CustomerSaleAndFinancialDataModel !== null ? (defaultValues.CustomerSaleAndFinancialDataModel.a8 !== null ? (defaultValues.CustomerSaleAndFinancialDataModel.a8.includes("-") ? "0" : defaultValues.CustomerSaleAndFinancialDataModel.a8 ) : "0" ) +  " ریال" : ""}</h6></td>
                </tr>
                <hr/>
                <tr>
                  <td style={{textAlign : 'right'}}><h6>جمع</h6></td>
                  <td style={{textAlign : 'left'}}><h6 style={{textAlign : 'left'}}>{defaultValues != null && defaultValues.CustomerSaleAndFinancialDataModel !== null ? (defaultValues.CustomerSaleAndFinancialDataModel.a8 !== null ? (defaultValues.CustomerSaleAndFinancialDataModel.a8.includes("-") ? defaultValues.CustomerSaleAndFinancialDataModel.a8.replaceAll("-","") : "0" ) : "0") +  " ریال" : ""}</h6></td>
                </tr>
              </table>
            </CardContent>
            <hr/>
            <CardActions>
            <table width='100%'>
                <tr>
                  <td>
                  <Tooltip title="تغییر رمز">
                    <IconButton onClick={changePass}
                    color="dark"
                    //color={!darkMode && transparentNavbar ? "white" : "dark"}
                    >
                      <PasswordIcon />
                    </IconButton>
                  </Tooltip>
                    </td>
                  <td>
                    <Tooltip title="خروج">
                    <IconButton onClick={logout}
                      color="dark"
                      //color={!darkMode && transparentNavbar ? "white" : "dark"}
                      >
                      <LogoutIcon />
                    </IconButton></Tooltip>
                    </td>
                </tr>
              </table>
            </CardActions>
      </Card>
        </ArgonBox>
       </ArgonBox>

)
  );
}

export default SidenavFooter;
